import ReactDDOM from 'react-dom';
import React, { useState, useEffect } from "react";
import './registeration-option.css';
import Button from '@mui/material/Button';
import Carousel from '../../reusable-components/carousel/Carousel';
import { useNavigate } from "react-router-dom";
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Footer from '../../reusable-components/footer/footer';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const bull = (
    <Box
        component="span"
        sx={{ display: 'inline-block', mx: '2px', transform: 'scale(0.8)' }}
    >
        •
    </Box>
);


function RegisterationOption(props) {
    const navigate = useNavigate();
    const [open, setOpen] = React.useState(false);

    useEffect(() => {
    });

    return (
        <>
            <div className="first-verify__loginContainer">
                <div className='first-verify__leftContainer'>
                    <div className='first-verify__logo'></div>
                    <div className='first-verify__loginSubContainer update-password-margin textAlign'>
                        {/* <div>{props.content.registrationOption.registration}</div> */}
                        <span className='first-verify__loginHeading'>{props.content.registrationOption.registration}</span>
                        <span className='first-verify__registerationSubHeading'>{props.content.registrationOption.registrationNote}</span>
                        <br />
                        <div className="first-verify__registerationOptionContainer">
                            <Card sx={{ width: 250, textAlign: 'center', cursor: 'pointer' }} onClick={() => navigate("/registration-company")} >
                                <CardContent>
                                    <div className='icon-company'></div>
                                    <Typography sx={{ fontWeight: 600 }}>
                                        {props.content.registrationOption.companyRegistration}
                                    </Typography>
                                </CardContent>
                            </Card>

                            {/* <Card sx={{ width: 250, textAlign: 'center', marginLeft: 5, cursor: 'pointer' }} onClick={() => navigate("/registeration")}>
                                <CardContent>
                                    <div className='individual-company'></div>
                                    <Typography sx={{ fontWeight: 600 }}>
                                        {props.content.registrationOption.individualRegistration}
                                    </Typography>
                                </CardContent>
                            </Card> */}
                        </div>
                    </div>
                    <div className='back-login-container'>
                        {/* <p style={{ fontWeight: 600 }} className="text-muted">Already have an account? <a  className="login-button-backtologin center-align " href="/"  >{props.content.registrationOption.backToLogin}</a></p> */}
                    </div>
                    <div className='back-login-container '>
                      <p className=''> {props.content.registrationOption.login}
                        <Button variant="text" sx={{ color: "#2A93DB", fontWeight: 500,textTransform:"capitalize" }} onClick={() => navigate("/")}>{props.content.registrationOption.backToLogin}</Button></p> 
                    </div>
                    <div className='footer-container'>
                        <Footer className={"footer-option"} />
                    </div>

                </div>
                <div className='first-verify__rightContainer'>
                    <div className='first-verify__rightSubContainer'>
                        <div className='first-verify__carousel-container'>
                            <Carousel />
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default RegisterationOption;

